import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
import { handleContactSubmit } from '../mock';
import { toast } from 'sonner';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Mock submission
    setTimeout(() => {
      const result = handleContactSubmit(formData);
      if (result.success) {
        toast.success(result.message);
        setFormData({
          name: '',
          email: '',
          company: '',
          service: '',
          message: ''
        });
      }
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <section id="contacto" style={{
      backgroundColor: '#000000',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{
          fontSize: '48px',
          fontWeight: 600,
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          color: '#FFFFFF',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          Solicita tu Presupuesto
        </h2>
        
        <p style={{
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: 1.5,
          color: 'rgba(255, 255, 255, 0.85)',
          marginBottom: '60px',
          textAlign: 'center'
        }}>
          Cuéntanos sobre tu proyecto y te contactaremos con una propuesta personalizada
        </p>

        <form onSubmit={handleSubmit} style={{
          backgroundColor: '#121212',
          border: '1px solid rgba(255, 255, 255, 0.25)',
          padding: '40px'
        }}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>Nombre Completo *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: '#000000',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '0px',
                color: '#FFFFFF',
                fontSize: '16px',
                outline: 'none',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00FFD1';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.25)';
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>Email Corporativo *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: '#000000',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '0px',
                color: '#FFFFFF',
                fontSize: '16px',
                outline: 'none',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00FFD1';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.25)';
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>Empresa *</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: '#000000',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '0px',
                color: '#FFFFFF',
                fontSize: '16px',
                outline: 'none',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00FFD1';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.25)';
              }}
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>Servicio de Interés *</label>
            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: '#000000',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '0px',
                color: '#FFFFFF',
                fontSize: '16px',
                outline: 'none',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00FFD1';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.25)';
              }}
            >
              <option value="" style={{ backgroundColor: '#000000' }}>Selecciona un servicio</option>
              <option value="big-data" style={{ backgroundColor: '#000000' }}>Big Data</option>
              <option value="machine-learning" style={{ backgroundColor: '#000000' }}>Machine Learning</option>
              <option value="blockchain" style={{ backgroundColor: '#000000' }}>Blockchain</option>
              <option value="impresion-3d" style={{ backgroundColor: '#000000' }}>Impresión 3D</option>
              <option value="ciberseguridad" style={{ backgroundColor: '#000000' }}>Ciberseguridad</option>
              <option value="desarrollo-apps" style={{ backgroundColor: '#000000' }}>Desarrollo de Apps</option>
              <option value="iot" style={{ backgroundColor: '#000000' }}>IoT</option>
            </select>
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{
              display: 'block',
              fontSize: '16px',
              fontWeight: 500,
              color: '#FFFFFF',
              marginBottom: '8px'
            }}>Mensaje *</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              placeholder="Cuéntanos más sobre tu proyecto y necesidades..."
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: '#000000',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '0px',
                color: '#FFFFFF',
                fontSize: '16px',
                outline: 'none',
                transition: 'all 0.3s ease',
                boxSizing: 'border-box',
                resize: 'vertical'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#00FFD1';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'rgba(255, 255, 255, 0.25)';
              }}
            />
          </div>

          <button 
            type="submit" 
            className="btn-primary"
            disabled={isSubmitting}
            style={{
              width: '100%',
              opacity: isSubmitting ? 0.6 : 1,
              cursor: isSubmitting ? 'not-allowed' : 'pointer'
            }}
          >
            {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
            {isSubmitting ? <CheckCircle size={20} /> : <Send size={20} />}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;